/**
 * Retorna a URL correta para um arquivo.
 * Se a URL já é absoluta (https://), retorna como está.
 * Se é relativa (/uploads/...), adiciona o prefixo da API.
 */
export function getFileUrl(path: string | null | undefined): string {
    if (!path) return ''
    if (path.startsWith('http://') || path.startsWith('https://')) return path
    const base = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')
    return `${base}${path.startsWith('/') ? '' : '/'}${path}`
}
